import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";
import { useAuthStatus } from "../../hooks/useAuthStatus";

import { connect } from "react-redux";
import { Link } from "react-router-dom";

// Reactstrap
// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

import porcherMark from "../../assets/images/porcher-logo.png";
import porcherWordmark from "../../assets/images/porcher-wordmark.png";

//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";

const Header = props => {
  const [search, setsearch] = useState(false);
  const { isAuthenticated } = useAuthStatus();

  // A desktop "collapsed" state left over from before the window was
  // shrunk would otherwise stay stuck (hiding the sidebar's text) until the
  // next hamburger click — clear it as soon as we cross into mobile width.
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 992) {
        document.body.classList.remove("vertical-collpsed");
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function tToggle() {
    var body = document.body;
    // Use the viewport width, not window.screen.width (which reflects the
    // physical monitor resolution and stays "desktop-sized" even when the
    // browser window itself is narrow) — otherwise a narrow desktop window
    // wrongly takes the desktop collapse branch instead of the mobile one.
    if (window.innerWidth < 992) {
      // Mobile: off-canvas overlay only. Always drop any leftover desktop
      // "collapsed" state so it can't get stuck on and hide the menu text
      // after a resize (e.g. collapse on desktop, then shrink the window).
      body.classList.remove("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    } else {
      // Desktop: sidebar-enable has no CSS effect at this width on its own,
      // so keep it mirroring vertical-collpsed instead of toggling it
      // independently — toggling both separately let them drift out of sync.
      const collapsed = body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable", collapsed);
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">

            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <span className="d-inline-flex align-items-center gap-2">
                    <img src={porcherMark} alt="" height="34" />
                    <img src={porcherWordmark} alt="Porcher" height="18" />
                  </span>
                </span>
                <span className="logo-lg">
                  <span className="d-inline-flex align-items-center gap-2">
                    <img src={porcherMark} alt="" height="34" />
                    <img src={porcherWordmark} alt="Porcher" height="18" />
                  </span>
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <span className="d-inline-flex align-items-center gap-2">
                    <img src={porcherMark} alt="" height="34" />
                    <span className="fw-bold text-white fs-5">Porcher</span>
                  </span>
                </span>
                <span className="logo-lg">
                  <span className="d-inline-flex align-items-center gap-2">
                    <img src={porcherMark} alt="" height="34" />
                    <span className="fw-bold text-white fs-5">Porcher</span>
                  </span>
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            <form className="app-search d-none d-lg-block">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={props.t("Search") + "..."}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search);
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {isAuthenticated ? (
              <>
                <NotificationDropdown />
                <ProfileMenu />
                <div
                  onClick={() => {
                    props.showRightSidebarAction(!props.showRightSidebar);
                  }}
                  className="dropdown d-inline-block"
                >
                  <button
                    type="button"
                    className="btn header-item noti-icon right-bar-toggle"
                  >
                    <i className="bx bx-cog" />
                  </button>
                </div>
              </>
            ) : (
              <Link to="/login" className="btn btn-primary btn-sm px-3 ms-2">
                Sign In
              </Link>
            )}
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
